import { Box } from '@wix/design-system';
import { FC } from 'react';
import clsx from 'clsx';
import { useProfileContext } from '../../Contexts/ProfileContext';
import ReviewSummaryContent from './components/ReviewSummaryContent';
import NoReviewsDesktop from './components/NoReviewsDesktop';
import s from './ProviderReviewSummary.module.scss';

interface ProviderReviewSummaryProps {
  isStickyMobileView: boolean;
  isMobileView: boolean;
  containerClassName?: string;
}

const ProviderReviewSummary: FC<ProviderReviewSummaryProps> = ({
  isStickyMobileView,
  isMobileView,
  containerClassName,
}) => {
  const {
    partnerProfile: { providerRating },
    enabled: isUserMPAutomatchEnabled,
  } = useProfileContext();

  const className = clsx(
    s.providerReviewSummary,
    isMobileView && s.mobileView,
    isStickyMobileView && s.stickyMobileView,
    containerClassName,
  );

  const reviewsCount = providerRating?.reviewsCount ?? 0;
  const averageRating = providerRating?.averageReviewRating ?? 0;
  const completedProjects = providerRating?.completedProjects ?? 0;

  const hasReviews = reviewsCount > 0;
  const shouldShowReviews = isUserMPAutomatchEnabled || hasReviews;

  if (!shouldShowReviews) {
    return null;
  }

  if (!hasReviews && !isMobileView) {
    return (
      <NoReviewsDesktop
        isMobileView={isMobileView}
        isStickyMobileView={isStickyMobileView}
        completedProjects={completedProjects}
        containerClassName={containerClassName}
      />
    );
  }

  return (
    <Box
      direction="horizontal"
      dataHook="provider-review-summary"
      className={className}
    >
      <ReviewSummaryContent
        isMobileView={isMobileView}
        isStickyMobileView={isStickyMobileView}
        averageRating={averageRating}
        reviewsCount={reviewsCount}
        completedProjects={completedProjects}
        hasReviews={hasReviews}
      />
    </Box>
  );
};

export default ProviderReviewSummary;
